/* ============ WYSUWANY KOSZYK ============ */
(function(){
  var drawer=document.querySelector('[data-cart-drawer]');
  var overlay=document.querySelector('[data-cart-overlay]');
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var fmt=new Intl.NumberFormat('pl-PL',{style:'currency',currency:(drawer&&drawer.dataset.currency)||'PLN'});
  function money(c){return fmt.format(c/100)}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}

  var TRASH='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>';

  function render(cart){
    if(!drawer)return;
    drawer.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=cart.item_count});
    document.querySelectorAll('.cart-count').forEach(function(e){e.textContent=cart.item_count;e.hidden=cart.item_count===0});
    var list=drawer.querySelector('[data-cart-items]'),empty=drawer.querySelector('[data-cart-empty]'),foot=drawer.querySelector('[data-cart-foot]');
    empty.hidden=cart.item_count>0;foot.hidden=cart.item_count===0;
    var ship=drawer.querySelector('[data-ship]');if(ship)ship.hidden=cart.item_count===0;
    var t=drawer.querySelector('.cdr-timer');if(t)t.hidden=cart.item_count===0;
    list.innerHTML=cart.items.map(function(it,i){
      var variant=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="cdr-var">'+esc(it.variant_title)+'</div>':'';
      var old=it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'';
      var disc=(it.line_level_discount_allocations||[]).map(function(d){return '<div class="cdr-disc">🏷️ '+esc(d.discount_application&&d.discount_application.title||'Rabat')+' (-'+money(d.amount)+')</div>'}).join('');
      return '<div class="cdr-item" data-line="'+(i+1)+'" data-qty="'+it.quantity+'">'+
        '<a class="cdr-img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="" loading="lazy">':'')+'</a>'+
        '<div class="cdr-info"><a class="cdr-title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+variant+disc+
          '<div class="cdr-qty"><button type="button" data-qty-dec aria-label="Mniej">−</button><span>'+it.quantity+'</span><button type="button" data-qty-inc aria-label="Więcej">+</button></div></div>'+
        '<div class="cdr-right"><button type="button" class="cdr-del" data-remove aria-label="Usuń">'+TRASH+'</button><div class="cdr-price">'+old+'<b>'+money(it.final_line_price)+'</b></div></div>'+
      '</div>';
    }).join('');
    drawer.querySelector('[data-cart-total]').textContent=money(cart.total_price);
    var save=drawer.querySelector('[data-cart-save]');
    var saved=(cart.original_total_price||0)-cart.total_price;
    if(save){save.hidden=!(saved>0);save.querySelector('b').textContent=money(saved);}
    if(ship){
      var th=parseInt(drawer.dataset.threshold,10)||0;
      var left=th-cart.total_price;
      var msg=ship.querySelector('[data-ship-msg]'),fill=ship.querySelector('[data-ship-fill]');
      if(th<=0||left<=0){msg.textContent=drawer.dataset.msgOk;fill.style.width='100%';ship.classList.add('ok');}
      else{msg.textContent=drawer.dataset.msgLeft.replace('{kwota}',money(left));fill.style.width=Math.max(4,Math.round(cart.total_price/th*100))+'%';ship.classList.remove('ok');}
    }
  }
  function refresh(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){render(c);return c})}
  function change(line,qty){
    drawer.classList.add('busy');
    return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json()}).then(function(c){render(c);drawer.classList.remove('busy')})
      .catch(function(){drawer.classList.remove('busy');refresh()});
  }

  // Licznik rezerwacji koszyka
  var timerEl=drawer&&drawer.querySelector('[data-cart-timer]'),timerInt;
  function startTimer(){
    if(!timerEl)return;
    var span=(parseInt(drawer.dataset.minutes,10)||5)*60000,key='bz_cart_end',end=0;
    try{end=parseInt(sessionStorage.getItem(key),10)||0}catch(e){}
    if(!end||end<=Date.now()){end=Date.now()+span;try{sessionStorage.setItem(key,String(end))}catch(e){}}
    clearInterval(timerInt);
    function tick(){
      var d=Math.floor((end-Date.now())/1000);
      if(d<=0){end=Date.now()+span;try{sessionStorage.setItem(key,String(end))}catch(e){}d=Math.floor(span/1000)}
      timerEl.textContent=String(Math.floor(d/60)).padStart(2,'0')+':'+String(d%60).padStart(2,'0');
    }
    tick();timerInt=setInterval(tick,1000);
  }

  function open(){
    if(!drawer){window.location.href=root+'cart';return}
    drawer.classList.add('open');overlay.classList.add('open');
    drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('cdr-lock');
    startTimer();
  }
  function close(){
    if(!drawer)return;
    drawer.classList.remove('open');overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('cdr-lock');
  }
  window.BZCart={open:open,close:close,refresh:refresh,render:render};

  if(!drawer)return;
  var init=document.querySelector('[data-cart-init]');
  try{render(JSON.parse(init.textContent))}catch(e){refresh()}
  overlay.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  drawer.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-close]')){close();return}
    var item=e.target.closest('.cdr-item');if(!item)return;
    var line=parseInt(item.dataset.line,10),q=parseInt(item.dataset.qty,10);
    if(e.target.closest('[data-qty-inc]'))change(line,q+1);
    else if(e.target.closest('[data-qty-dec]'))change(line,Math.max(0,q-1));
    else if(e.target.closest('[data-remove]'))change(line,0);
  });
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-open-cart]');
    if(a){e.preventDefault();refresh().then(open)}
  });
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh()});
})();
